<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'pii.details.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      (click)="dialogRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    @if (productInventoryItem$ | async; as pii) {
      <div class="row col-12">
        <div
          class="col-12"
          [ngClass]="{
            'col-md-6':
              (documentPreviewPermission$ | async) && pii?.documents?.length,
          }"
        >
          <div class="d-flex justify-content-between align-items-end">
            <p class="caption mb-1">
              {{ 'common.titleBaseInformation' | translate }}
            </p>
          </div>
          <hr class="mt-0" />
          <div class="row">
            <div
              *appRequirePermission="'patientInformation'"
              class="col-12 col-md-6 row align-items-center mb-2"
            >
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'common.patientName' | translate
              }}</label>
              <div class="col-12 col-lg-8">
                {{ pii.sample?.serviceData?.patientInformation?.firstName }}
                {{ pii.sample?.serviceData?.patientInformation?.lastName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 row align-items-center mb-2">
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'pii.details.kitId' | translate
              }}</label>
              <div class="col-12 col-lg-8">
                {{ pii.kitId }}
              </div>
            </div>
            <div class="col-12 col-md-6 row align-items-center mb-2">
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'pii.details.product' | translate
              }}</label>
              <div class="col-12 col-lg-8">
                {{ pii.product?.internalName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 row align-items-center mb-2">
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'pii.details.partner' | translate
              }}</label>

              <div class="col-12 col-lg-8">
                {{ pii.partner?.name }}
              </div>
            </div>
            <div
              *appRequirePermission="'laboratory.access'"
              class="col-12 col-md-6 row align-items-center mb-2"
            >
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'pii.details.laboratory' | translate
              }}</label>
              <div class="col-12 col-lg-8">
                {{ pii.sample?.kit?.laboratory }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 row align-items-center mb-2">
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'pii.details.generated' | translate
              }}</label>
              <div class="col-12 col-lg-8">
                {{ pii.generated.timestamp | date }}
              </div>
            </div>
            <div class="col-12 col-md-6 row align-items-center mb-2">
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'pii.details.statusChanged' | translate
              }}</label>

              <div class="col-12 col-lg-8">
                {{ pii.lastStatusChanged | date }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 row align-items-center mb-2">
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'pii.details.status' | translate
              }}</label>

              <div class="col-12 col-lg-8">
                {{ pii.lastStatus }}
              </div>
            </div>
            <ng-container *appRequirePermission="'pii.highRiskInfo'">
              @if (pii.lastStatusChangedReason) {
                <div class="col-12 col-md-6 row align-items-center mb-2">
                  <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                    'pii.details.statusReason' | translate
                  }}</label>

                  <div class="col-12 col-lg-8">
                    {{ pii.lastStatusChangedReason }}
                    @if (getStatusReason(pii); as documentStatus) {
                      {{ ' (' + documentStatus + ')' }}
                    }
                  </div>
                </div>
              }
            </ng-container>
          </div>
          <div class="d-flex justify-content-between align-items-end">
            <p class="caption mb-1">
              {{ 'pii.details.serviceInformation' | translate }}
            </p>
          </div>
          <hr class="mt-0" />
          <div *appRequirePermission="'medicalInformation'" class="row">
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="partner-row"
            >
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'serviceData.details.nipt.genderInformation' | translate
              }}</label>
              <div class="col-12 col-lg-8">
                {{
                  pii.sample?.serviceData?.serviceInformation?.nipt
                    ?.provideGenderInformation
                    ? 'YES'
                    : 'NO'
                }}
              </div>
            </div>
            <div
              class="col-12 col-md-6 row align-items-center mb-2"
              data-cy="partner-row"
            >
              <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                'serviceData.details.nipt.incidentalFindings' | translate
              }}</label>
              <div class="col-12 col-lg-8">
                {{
                  pii.sample?.serviceData?.serviceInformation?.nipt
                    ?.incidentalFindings
                    ? 'YES'
                    : 'NO'
                }}
              </div>
            </div>
          </div>
          <div *appRequirePermission="'serviceData.details'" class="row">
            <div class="col-12 row align-items-center mb-2">
              <label class="label col-12 col-lg-2 mb-0 text-lg-end">{{
                'pii.details.serviceData' | translate
              }}</label>
              <div class="col-12 col-lg-10">
                <a
                  class="cursor-pointer text-primary"
                  triggers="hover"
                  [ngbTooltip]="
                    'pii.details.tooltips.serviceDataDetails' | translate
                  "
                  (click)="openServiceDataDetails(pii.sample?.serviceData?.id)"
                >
                  {{ pii.sample?.serviceData?.referenceKey }}
                </a>
              </div>
            </div>
          </div>
          <div *appRequirePermission="'sample.details'" class="row">
            <div class="col-12 row align-items-center mb-2">
              <label class="label col-12 col-lg-2 mb-0 text-lg-end">{{
                'pii.details.sample' | translate
              }}</label>
              <div class="col-12 col-lg-10">
                <a
                  class="cursor-pointer text-primary"
                  triggers="hover"
                  [ngbTooltip]="
                    'pii.details.tooltips.sampleDetails' | translate
                  "
                  (click)="openSampleDetails(pii.sample?.id)"
                >
                  {{ pii.sample?.kitId }}
                </a>
              </div>
            </div>
          </div>

          @if (canViewCommentsAndNotes()) {
            <div class="d-flex justify-content-between align-items-end">
              <p class="caption mb-1">
                {{ 'serviceData.details.commentsAndNotes' | translate }}
              </p>
            </div>
            <hr class="mt-0" />
            <div class="row">
              <div
                *appRequirePermission="'serviceData.details.patientState'"
                class="col-12 col-md-6 row align-items-center mb-2"
                data-cy="partner-row"
              >
                <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                  'serviceData.details.patientState' | translate
                }}</label>
                <div class="col-12 col-lg-8">
                  {{
                    getPropertyFromServiceInformation(
                      pii.sample?.serviceData?.serviceInformation,
                      'comments'
                    ) || '—'
                  }}
                </div>
              </div>
              <div
                *appRequirePermission="'serviceData.details.notes'"
                class="col-12 col-md-6 row align-items-center mb-2"
                data-cy="partner-row"
              >
                <label class="label col-12 col-lg-4 mb-0 text-lg-end">{{
                  'serviceData.details.notes' | translate
                }}</label>
                <div class="col-12 col-lg-8">
                  {{ pii.sample?.serviceData?.notes || '—' }}
                </div>
              </div>
            </div>
          }
        </div>

        @if (pii?.documents?.length) {
          <div *appRequirePermission="'pii.details'" class="col-12 col-md-6">
            <div class="d-flex justify-content-between align-items-end">
              <p class="caption mb-1">
                {{ 'pii.details' | translate }}
              </p>
            </div>
            <app-document-preview [uri]="onShowPdfSubject$ | async" />
          </div>
        }
      </div>
      <ng-container *appRequirePermission="'pii.details.documentsList'">
        <div class="d-flex justify-content-between align-items-end">
          <p class="caption mb-1">
            {{ 'pii.details.documentsTitle' | translate }}
          </p>
        </div>
        <hr class="mt-0" />
        <app-product-inventory-item-documents
          [pii]="pii"
          (showPDF)="onShowPdfSubject$.next($event)"
        />
        <div class="d-flex justify-content-between align-items-end mt-3">
          <p class="caption mb-1">
            {{ 'pii.details.reportsTitle' | translate }}
          </p>
        </div>
        <hr class="mt-0" />
        <app-reports-list-section [reportIds]="pii.reports" [pii]="pii" />
      </ng-container>
    } @else {
      <div class="py-4 loading"></div>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="dialogRef.close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
